<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="6">
        <v-card>
          <sys-data-table
            v-model:selected="itensSelecionadosDisponiveis"
            :headers="headers"
            :items="disponiveis"
            :search="pesquisar_disponiveis"
            :height="300"
            :item-height="45"
            show-select
            item-key="idproduto"
            class="cursor-pointer elevation-1"
            @click:row="moverParaSelecionados($event.row)"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Produtos Disponíveis</v-toolbar-title>
              </v-toolbar>

              <v-spacer />

              <v-text-field
                v-model="pesquisar_disponiveis"
                append-icon="mdi-magnify"
                label="Pesquisar"
              />
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn 
                color="primary" 
                icon
                @click.stop="moverParaSelecionados(item)"
              >
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </template>

            <template #footer.prepend>
              <v-btn 
                v-if="itensSelecionadosDisponiveis.length > 0"
                color="primary"
                small
                class="ml-2"
                @click="moverSelecionadosParaSelecionados"
              >
                Mover multi <v-icon color="white" class="ml-2">mdi-transfer-right</v-icon>
              </v-btn>
            </template>
          </sys-data-table>
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card>
          <sys-data-table
            v-model:selected="itensSelecionadosSelecionados"
            :headers="headers"
            :items="selecionados"
            :search="pesquisar_selecionados"
            :height="300"
            :item-height="45"
            show-select
            item-key="idproduto"
            class="cursor-pointer elevation-1"
            @click:row="moverParaDisponiveis($event.row)"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Produtos Selecionados</v-toolbar-title>
              </v-toolbar>

              <v-spacer />

              <v-text-field
                v-model="pesquisar_selecionados"
                append-icon="mdi-magnify"
                label="Pesquisar"
              />
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn 
                color="red" 
                icon
                @click.stop="moverParaDisponiveis(item)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </template>

            <template #footer.prepend>
              <v-btn 
                v-if="itensSelecionadosSelecionados.length > 0"
                color="primary" 
                small
                class="ml-2"
                @click="moverSelecionadosParaDisponiveis"
              >
                <v-icon color="white" class="mr-2">mdi-transfer-left</v-icon> Mover multi
              </v-btn>
            </template>
          </sys-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
import Api from '@/api/api.js';

const props = defineProps({
  modelValue: {
    type: Array,
    required: true
  },
});

const emit = defineEmits(['update:modelValue']);

const headers = [
  { text: 'ID Produto', value: 'idproduto' },
  { text: 'Descrição Produto', value: 'descricao_produto' },
];

const pesquisar_disponiveis = ref('');
const pesquisar_selecionados = ref('');
const disponiveis = ref([]);
const selecionados = ref(props.modelValue);
const itensSelecionadosDisponiveis = ref([]);
const itensSelecionadosSelecionados = ref([]);

const moverSelecionadosParaSelecionados = () => {
  itensSelecionadosDisponiveis.value.forEach((item) => {
    disponiveis.value = disponiveis.value.filter((i) => i.idproduto !== item.idproduto);
    selecionados.value.push(item);
  });
  itensSelecionadosDisponiveis.value = [];
  emit('update:modelValue', selecionados.value);
};

const moverSelecionadosParaDisponiveis = () => {
  itensSelecionadosSelecionados.value.forEach((item) => {
    selecionados.value = selecionados.value.filter((i) => i.idproduto !== item.idproduto);
    disponiveis.value.push(item);
  });
  itensSelecionadosSelecionados.value = [];
  emit('update:modelValue', selecionados.value);
};

const moverParaSelecionados = (item) => {  
  disponiveis.value = disponiveis.value.filter((i) => i.idproduto !== item.idproduto);
  selecionados.value.push(item);
  emit('update:modelValue', selecionados.value);
};

const moverParaDisponiveis = (item) => {
  selecionados.value = selecionados.value.filter((i) => i.idproduto !== item.idproduto);
  disponiveis.value.push(item);
  emit('update:modelValue', selecionados.value);
};

const listaDeProdutosDistintos = () => {
  const params = { ignorar_ids: props.modelValue.map(m => m.idproduto) };
  Api.post('drp/analise-parametros-produto/lista-de-produtos-distintos', params)
    .then(response => disponiveis.value = response.data.produtos);
}

watch(
  () => props.modelValue,
  (newVal) => {
    selecionados.value = [...newVal];
    listaDeProdutosDistintos();
  },
  { immediate: true }
);
</script>

<style scoped>
.v-card {
  margin-bottom: 16px;
}
</style>